export default __webpack_public_path__ + "static/media/Calendar.cf16fbc7.svg";